import { useEffect, useState } from 'react';
import { Dialogue, DialogueMember, DialogueMessage } from '../../../#interfaces/interfaces';
import MessageBox from './MessageBox';
import './messagesBoxes.css';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store';
import CloseIcon from '../../../assets/close-icon-white-64.png';
import { deselectDialogue, openCloseDialogueBox, selectDialogue, updateDialogueMessage } from '../../../features/sessions/sessionDialogues';
import { getUserGenericConfig } from '../../../features/sessions/sessionConfig/sessionUserConfigurations';

const getVisibleDialogueBoxes = (screenWidth: number): number => {
    return screenWidth >= 1200 ? 4 : screenWidth >= 950 ? 4 : screenWidth >= 700 ? 3 : screenWidth >= 500 ? 2 : 1;
};

export default function MessagesBoxes(){
    const currentUser = useSelector((state: RootState) => state.session.currentUser);
    const authHeaders = useSelector((state: RootState) => state.session.authHeaders);
    const selectedDialogues = useSelector((state: RootState) => state.sessionDialogues.selectedDialogues);
    const dispatch = useDispatch<AppDispatch>();
    const openedDialogues = useSelector((state: RootState) => state.sessionDialogues.openedDialogueBox);
    const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);
    const [visibleDialogueBoxes, setVisibleDialogueBoxes] = useState(3);
    const remainingDialogues = selectedDialogues.length - visibleDialogueBoxes;
    const userDialogues = useSelector((state: RootState) => state.sessionDialogues.userDialogues);

    useEffect(() => {

        const handleResize = () => {
            setVisibleDialogueBoxes(getVisibleDialogueBoxes(window.innerWidth));
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [window.innerWidth]);

    async function handleOpenDialogue(userNickname: string){
        dispatch(openCloseDialogueBox({nickname: userNickname}))
    }

    async function handleDeselectDialogue(userDialogue: string) {
        
        try {
            
            if (!selectedDialogues.includes(userDialogue)) {
                return dispatch(selectDialogue({ nickname: userDialogue }));
            } else {
                return dispatch(deselectDialogue({ nickname: userDialogue }));
            }

        } catch (error) {
            console.error(error);
        }
    }

    async function handleReadLastDialogueMessage(dialogue: Dialogue){

        
        if (authHeaders && currentUser && currentUser?.nickname ){

            const dialogueMessagesReceived = dialogue.dialogueMessages?.filter( dialogueMessage => dialogueMessage.senderId != currentUser.id)
            const lastDialogueMessageReceivedId = dialogueMessagesReceived?.at(-1)?.id
            
                    if ( lastDialogueMessageReceivedId){
        
                        const response = await dispatch(updateDialogueMessage({
                                                                        authHeaders: authHeaders,
                                                                        urlParams: {
                                                                            userNickname: currentUser?.nickname,
                                                                            dialogueMessageId: lastDialogueMessageReceivedId
                                                                        },
                                                                        requestBody:{
                                                                            visualized: true
                                                                        }
                                                                    }))
                                                                    
                            if(response.meta.requestStatus === 'fulfilled'){
                                dispatch(getUserGenericConfig({
                                    authHeaders,
                                    userNickname: currentUser.nickname,
                                  }))
                            } else (
                                console.warn('There is some error in message box component when dialogue message is updated')
                            )
                    }
        }
    }

    return(
            <div id='container-messages-boxes'>
                <ul>
                    {selectedDialogues.length > 0 && selectedDialogues.slice(0, visibleDialogueBoxes).map((userNickname: string, index: number) => (
                            
                        <li key={index}>
                                <div onClick={() => {
                                    const matchingDialogue = userDialogues.find((userDialogue: Dialogue) => {
                                    const members = userDialogue.dialogueMembers || [];
                                    const hasUserNickname = members.some(
                                        (member: DialogueMember) => member.user?.nickname === userNickname
                                    );
                                    const hasCurrentUserNickname = members.some(
                                        (member: DialogueMember) => member.user?.nickname === currentUser?.nickname
                                    );
                                    return members.length === 2 && hasUserNickname && hasCurrentUserNickname;
                                    });

                                    if (matchingDialogue) {
                                        handleReadLastDialogueMessage(matchingDialogue);
                                    }

                                    // return null;
                                }}>
                                    {openedDialogues.some(userDialogue => 
                                        userDialogue.dialogueMembers?.some(member => member.user?.nickname === userNickname)
                                    ) && (
                                        <MessageBox userNickname={userNickname}/>
                                    )}
                                    <div id='container-user-name'  onClick={() => {handleOpenDialogue(userNickname)}}>                                        
                                        <h3>{userNickname}</h3>
                                        <button  onClick={() => handleDeselectDialogue(userNickname)}>
                                            <img src={CloseIcon}/>
                                        </button>
                                    </div>
                                </div>
                                
                        </li>) 
                        )}

                        {remainingDialogues > 0 ?
                            <li>
                                <div id='container-remaining-dialogues'  >
                                    <h3>{`+${remainingDialogues}`}</h3>
                                </div>
                            </li>
                            :
                            null
                        }
                </ul>
            </div>  
    );
}
